import ScrollMaster from "./scroll";

export { ScrollMaster };
export default ScrollMaster;
